var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "brief-modal-overlay",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "brief-modal",
          attrs: { role: "dialog", "aria-labelledby": "skuBriefTitle" },
        },
        [
          _c("div", { staticClass: "brief-modal-header" }, [
            _c("div", { staticClass: "brief-modal-heading-row" }, [
              _c(
                "svg",
                {
                  staticClass:
                    "lucide lucide-file-text h-4 w-4 text-emerald-700",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M14 2v4a2 2 0 0 0 2 2h4" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M10 9H8" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M16 13H8" } }),
                  _vm._v(" "),
                  _c("path", { attrs: { d: "M16 17H8" } }),
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "brief-modal-nav" }, [
                _c(
                  "button",
                  {
                    staticClass: "brief-modal-nav-btn",
                    attrs: {
                      type: "button",
                      "aria-label": "Previous brief",
                      disabled: _vm.currentIndex === 0,
                    },
                    on: {
                      click: function ($event) {
                        _vm.currentIndex--
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-chevron-left h-4 w-4",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [_c("path", { attrs: { d: "m15 18-6-6 6-6" } })]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "brief-modal-nav-label" }, [
                  _vm._v(
                    "\n            Brief " +
                      _vm._s(_vm.currentIndex + 1) +
                      " of " +
                      _vm._s(_vm.draftBriefs.length) +
                      "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "brief-modal-nav-btn",
                    attrs: {
                      type: "button",
                      "aria-label": "Next brief",
                      disabled: _vm.currentIndex === _vm.draftBriefs.length - 1,
                    },
                    on: {
                      click: function ($event) {
                        _vm.currentIndex++
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-chevron-right h-4 w-4",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [_c("path", { attrs: { d: "m9 18 6-6-6-6" } })]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.currentDraft
              ? _c("div", { staticClass: "brief-title-row" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "lucide lucide-pencil brief-modal-meta-icon",
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "12",
                        height: "12",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", { attrs: { d: "m15 5 4 4" } }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDraft.title,
                        expression: "currentDraft.title",
                      },
                    ],
                    staticClass: "brief-title-input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.currentDraft.title },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.currentDraft, "title", $event.target.value)
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentDraft
              ? _c("div", { staticClass: "brief-modal-assignee-row" }, [
                  _c("div", { staticClass: "brief-assignee-select-wrap" }, [
                    _c(
                      "button",
                      {
                        staticClass: "brief-assignee-trigger",
                        attrs: {
                          type: "button",
                          role: "combobox",
                          "aria-autocomplete": "none",
                          "aria-expanded": _vm.assigneeMenuOpen
                            ? "true"
                            : "false",
                          "aria-controls": "sku-brief-assignee-menu",
                        },
                        on: { click: _vm.toggleAssigneeMenu },
                      },
                      [
                        _c(
                          "span",
                          { staticStyle: { "pointer-events": "none" } },
                          [
                            _c(
                              "span",
                              { staticClass: "brief-assignee-trigger-label" },
                              [
                                _vm.currentDraft.assigneeType !==
                                "agency_partner"
                                  ? _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-user-plus brief-assignee-trigger-icon",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("circle", {
                                          attrs: { cx: "9", cy: "7", r: "4" },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "19",
                                            x2: "19",
                                            y1: "8",
                                            y2: "14",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "22",
                                            x2: "16",
                                            y1: "11",
                                            y2: "11",
                                          },
                                        }),
                                      ]
                                    )
                                  : _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-building2 brief-assignee-trigger-icon",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M10 6h4" } }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M10 10h4" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M10 14h4" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M10 18h4" },
                                        }),
                                      ]
                                    ),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.currentDraft.assigneeType ===
                                        "agency_partner"
                                        ? "Agency partner"
                                        : "Specific Person"
                                    ) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            staticClass:
                              "lucide lucide-chevron-down brief-assignee-trigger-chevron",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "aria-hidden": "true",
                            },
                          },
                          [_c("path", { attrs: { d: "m6 9 6 6 6-6" } })]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.assigneeMenuOpen
                      ? _c(
                          "div",
                          {
                            staticClass: "brief-assignee-menu",
                            attrs: {
                              id: "sku-brief-assignee-menu",
                              role: "presentation",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "brief-assignee-option",
                                class: {
                                  "is-selected":
                                    _vm.currentDraft.assigneeType ===
                                    "specific_person",
                                },
                                attrs: { type: "button", role: "option" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAssigneeType(
                                      "specific_person"
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "brief-assignee-option-check",
                                  },
                                  [
                                    _vm.currentDraft.assigneeType ===
                                    "specific_person"
                                      ? _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "lucide lucide-check brief-assignee-check-icon",
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "24",
                                              height: "24",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "aria-hidden": "true",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: { d: "M20 6 9 17l-5-5" },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "brief-assignee-option-label",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-user-plus brief-assignee-option-icon",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "aria-hidden": "true",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("circle", {
                                          attrs: { cx: "9", cy: "7", r: "4" },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "19",
                                            x2: "19",
                                            y1: "8",
                                            y2: "14",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "22",
                                            x2: "16",
                                            y1: "11",
                                            y2: "11",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                Specific Person\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "brief-assignee-option",
                                class: {
                                  "is-selected":
                                    _vm.currentDraft.assigneeType ===
                                    "agency_partner",
                                },
                                attrs: { type: "button", role: "option" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAssigneeType("agency_partner")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "brief-assignee-option-check",
                                  },
                                  [
                                    _vm.currentDraft.assigneeType ===
                                    "agency_partner"
                                      ? _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "lucide lucide-check brief-assignee-check-icon",
                                            attrs: {
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              width: "24",
                                              height: "24",
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-width": "2",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                              "aria-hidden": "true",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: { d: "M20 6 9 17l-5-5" },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "brief-assignee-option-label",
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-building2 brief-assignee-option-icon",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "aria-hidden": "true",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", { attrs: { d: "M10 6h4" } }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M10 10h4" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M10 14h4" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "M10 18h4" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n                Agency partner\n              "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDraft.assigneeName,
                        expression: "currentDraft.assigneeName",
                      },
                    ],
                    staticClass: "brief-inline-control brief-inline-assignee",
                    attrs: { type: "text", placeholder: "person@brand.com" },
                    domProps: { value: _vm.currentDraft.assigneeName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.currentDraft,
                          "assigneeName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDraft.delivery_date,
                        expression: "currentDraft.delivery_date",
                      },
                    ],
                    staticClass: "brief-inline-control brief-inline-date",
                    attrs: { type: "date" },
                    domProps: { value: _vm.currentDraft.delivery_date },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.currentDraft,
                          "delivery_date",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.currentDraft
            ? _c("div", { staticClass: "brief-modal-content" }, [
                _c("div", { staticClass: "brief-modal-content-section" }, [
                  _c("label", { staticClass: "brief-modal-label" }, [
                    _vm._v("Overview"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDraft.overviewText,
                        expression: "currentDraft.overviewText",
                      },
                    ],
                    attrs: { rows: "3" },
                    domProps: { value: _vm.currentDraft.overviewText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.currentDraft,
                          "overviewText",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "brief-modal-content-section" }, [
                  _c("label", { staticClass: "brief-modal-label" }, [
                    _vm._v("Deliverables"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentDraft.deliverablesText,
                        expression: "currentDraft.deliverablesText",
                      },
                    ],
                    attrs: { rows: "8" },
                    domProps: { value: _vm.currentDraft.deliverablesText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.currentDraft,
                          "deliverablesText",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.currentDraftResult && !_vm.currentDraftResult.success
                  ? _c("div", { staticClass: "brief-modal-error" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.currentDraftResult.error) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "brief-modal-divider" }),
          _vm._v(" "),
          _c("div", { staticClass: "brief-modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "brief-modal-btn-outline",
                attrs: {
                  type: "button",
                  disabled: _vm.currentIndex === _vm.draftBriefs.length - 1,
                },
                on: {
                  click: function ($event) {
                    _vm.currentIndex++
                  },
                },
              },
              [
                _vm._v("\n        Next brief\n        "),
                _c(
                  "svg",
                  {
                    staticClass:
                      "lucide lucide-chevron-right brief-modal-meta-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [_c("path", { attrs: { d: "m9 18 6-6-6-6" } })]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "brief-modal-btn",
                attrs: { type: "button", disabled: _vm.isSubmitting },
                on: {
                  click: function ($event) {
                    return _vm.$emit("submit", { drafts: _vm.draftBriefs })
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "lucide lucide-user-plus brief-modal-btn-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" },
                    }),
                    _vm._v(" "),
                    _c("circle", { attrs: { cx: "9", cy: "7", r: "4" } }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "19", x2: "19", y1: "8", y2: "14" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "22", x2: "16", y1: "11", y2: "11" },
                    }),
                  ]
                ),
                _vm._v("\n        " + _vm._s(_vm.submitLabel) + "\n      "),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "brief-modal-close",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("i", { staticClass: "bi bi-x" })]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "brief-modal-title-group" }, [
      _c(
        "h2",
        { staticClass: "brief-modal-title", attrs: { id: "skuBriefTitle" } },
        [_vm._v("\n            Content Brief\n          ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }